<template>
  <FocusTrap>
    <div  id="mycard" class="card">

      <div class="card-header header-elements-inline" style="background-color: whitesmoke;padding: 10px;" >
        <h5 v-if="voucher.id == 0" class="card-title">Party Receipt Creation</h5>
        <h5 v-if="voucher.id > 0" class="card-title"> Doc No: {{voucher.doc_no}}  Party Receipt Updation</h5>
        <div class="header-elements">
          <div class="list-icons">
            <a class="list-icons-item" data-action="reload" @click="loadAll" ></a>
            <a class="list-icons-item" data-action="remove" @click="closeThis"></a>
          </div>
        </div>
      </div>

      <div class="card-body">

        <div class="row">

          <div class="col-md-3">
            <div class="form-group form-group-material">
              <label class="control-label text-semibold">Party</label>
              <select id="cmbledger" class="form-control select" autofocus="" required="" v-if="voucher" v-model="voucher.buyer_id" >
                <option v-for="ledger in buyers" v-bind:value="ledger.id">
                  {{ ledger.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-8">
          </div>

          <div class="col-md-1">
            <div class="form-group form-group-material">
              <label class="control-label text-semibold">Date</label>
              <input id="txtDate" type="date" class="form-control" v-if="voucher" v-model="voucher.doc_date">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="form-group form-group-material">
              <label class="control-label text-semibold">Amount</label>
              <input id="txtamount" type="number" class="form-control text-right" min="0"  step="any" placeholder="0.00"   v-if="voucher" v-model="voucher.amount"/>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group form-group-material">
              <label class="control-label text-semibold">Receiving Ledger</label>
              <select class="form-control" required="" v-if="voucher" v-model="voucher.rcpt_ldgr_id" >
                <option v-for="ledger in ledgers" v-bind:value="ledger.id">
                  {{ ledger.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-1" style="align-items: center">
            <label class="control-label">&nbsp;Reload</label>
            <button class="btn btn-outline-success form-control" data-toggle="tooltip" title="Click To load Bills" @click="loadPendingBills"  > <span class="icon-reload-alt"></span> </button>
          </div>
          <div class="col-md-5">
          </div>

        </div>

        <div class="row">
          <table class="table table-bordered table-columned table-hover">
            <thead style="background-color: lightgrey">
            <tr>
              <th style="width:50px;">S.No</th>
              <th >Invoice No</th>
              <th >Date</th>
              <th >Invoice Amount</th>
              <th >Balance</th>
              <th style="width:150px; text-align: right;">Rcpt Amt</th>
              <!--              <th style="width: 30px;">Action</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="(bill,i) in pendingbills" :key="i">
              <td>{{i + 1}}</td>
              <td>{{bill.invoice.doc_no}}</td>
              <td>{{bill.invoice.doc_date | dateFormatter}}</td>
              <td class="text-right">{{bill.invoice.net_amt}}</td>
              <td class="text-right">{{bill.invoice.balance_amt}}</td>
              <td style="padding: 0px;"><input class="form-control text-right" type="number" :max="bill.balance_amt" v-model="bill.rcpt_amount" @change="sum_display_totals" /></td>
            </tr>
            </tbody>
            <tfoot style="background-color: lightgrey;">
              <tr style="height: 40px;">
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right"></td>
                <td style="padding: 0px;" class="text-right font-weight-semibold">{{total_invoice_amt | cashierFormat}}</td>
                <td style="padding: 0px;" class="text-right font-weight-semibold">{{total_rcpt_amt | cashierFormat}}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="row" style="padding-top: 5px;">
          <div class="col-md-3">
            <div class="form-group form-group-material">
              <label class="control-label text-semibold">Narration</label>
              <textarea id="txtremarks" class="form-control" placeholder="Narration"  v-if="voucher" v-model="voucher.remarks" > </textarea>
            </div>
          </div>

          <div class="col-md-6">
          </div>

          <div class="col-md-3 text-right">
            <SaveButton title="Save" @handle_save_action="perform_save_action" style="margin: 1em;">Save</SaveButton>
            <CloseButton title="Clear" @handle_close_action="clear" >Clear</CloseButton>
          </div>

        </div>
      </div>

    </div>
  </FocusTrap>
</template>

<script>
import moment from 'moment-timezone'
import { userService } from '@/store/auth-header.js'
import { store } from '@/store/store.js'
import SaveButton from '../../../components/core/buttons/SaveButton'
import CloseButton from '../../../components/core/buttons/CloseButton'
export default {
  name: 'PartyReceiptForm',
  store,
  components: {
    CloseButton,
    SaveButton,
  },
  data () {
    return {
      readonly: false,
      buyers: [],
      ledgers:[],
      pendingbills:[],
      total_rcpt_amt: 0,
      total_invoice_amt: 0,
      voucher: JSON.parse('{"id":0,"finyear":0,"doc_no":"","doc_date":"0001-01-01","ref_no":"","ref_date":"0001-01-01","buyer_id":0,"buyer":{"id":0,"type":0,"name":""},"rcpt_ldgr_id":0,"received_ledger":{"id":0,"type":0,"name":""},"amount":0,"remarks":"","brn_id":0,"cmp_id":0,"locked":false,"list":[]}'),
    }
  },
  props: {
    myvoucher: {
      type: Object,
      default: () => JSON.parse('{"id":0,"finyear":0,"doc_no":"","doc_date":"0001-01-01","ref_no":"","ref_date":"0001-01-01","buyer_id":0,"buyer":{"id":0,"type":0,"name":""},"rcpt_ldgr_id":0,"received_ledger":{"id":0,"type":0,"name":""},"amount":0,"remarks":"","brn_id":0,"cmp_id":0,"locked":false,"list":[]}')
    }
  },
  beforeMount () {
    this.voucher = this.myvoucher;
  },
  created () {
    this.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
    this.$data.voucher.ref_date = moment().format('YYYY-MM-DD');
  },
  mounted () {
    const self = this;

    self.loadBuyer();
    self.loadReceivedLedgers();

    $('[data-toggle="tooltip"]').tooltip();

    if (self.$data.voucher.doc_date == '0001-01-01') {
      this.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
      this.$data.voucher.ref_date = moment().format('YYYY-MM-DD');
    }


    if(self.$data.voucher.buyer_id > 0 ) {
      // self.loadPendingBills();

      if(self.$data.pendingbills.length == 0) {

        self.$data.voucher.list.forEach(line => {
          let brkup = JSON.parse('{"id":0,"master_id":0,"idx":0,"saleinvoice_id":0,"invoice":{"id":0,"status":"Active","finyear":0,"doc_no":0,"doc_date":"2000-01-01","buyer_id":0,"net_amt":0,"rcpt_amt":0,"balance_amt":0,"rcpt_amount":0},"rcpt_amount":0}');
          brkup.id = line.id;
          brkup.master_id = line.master_id;
          brkup.idx = line.idx;
          brkup.saleinvoice_id = line.saleinvoice_id;
          brkup.rcpt_amount = line.rcpt_amount;
          brkup.balance_amt = line.invoice.balance_amt + line.rcpt_amount;

          brkup.invoice.id = line.invoice.id;
          brkup.invoice.doc_no = line.invoice.doc_no;
          brkup.invoice.doc_date = line.invoice.doc_date;
          brkup.invoice.buyer_id = line.invoice.buyer_id;
          brkup.invoice.net_amt = line.invoice.net_amt;
          brkup.invoice.rcpt_amt = line.invoice.rcpt_amt;
          brkup.invoice.balance_amt = line.invoice.balance_amt + line.rcpt_amount;

          self.$data.pendingbills.push(brkup);
        });
      }
    }


    $('#cmbledger').focus();
  },
  filters:{
    dateFormatter(val){
      return moment(val).format('DD-MM-YYYY');
    },
    cashierFormat(val){
      if(val == null){
        return ""
      }
      return parseFloat(val).toFixed(2);
    }
  },
  methods: {
    indianFormat (val) {
      return parseFloat(val).toFixed(2)
    },
    closeThis () {
      this.$emit('partyreceipt_window_closed');
      if (this.voucher.id == 0) {
        this.$router.push('/');
      }
    },
    sum_display_totals(){
      const self = this;

      let total_rcpt_amt = 0;
      let total_invoice_amt = 0;

      self.$data.pendingbills.forEach((line) =>{
        if( parseFloat(line.rcpt_amount) > 0 ) {
          total_rcpt_amt += parseFloat(line.rcpt_amount);
        }
        total_invoice_amt += parseFloat(line.invoice.net_amt);
      });

      self.$data.total_rcpt_amt = total_rcpt_amt;
      self.$data.total_invoice_amt = total_invoice_amt;
    },
    clear () {
      const self = this;
      self.$data.detail = JSON.parse('{"id":0,"master_id":0,"idx":0,"saleinvoice_id":0,"invoice":{"id":0,"status":"Active","finyear":0,"doc_no":0,"doc_date":"2000-01-01","buyer_id":0,"net_amt":0,"rcpt_amt":0,"balance_amt":0,"rcpt_amount":0},"rcpt_amount":0}');
      self.$data.voucher = JSON.parse('{"id":0,"finyear":0,"doc_no":"","doc_date":"0001-01-01","ref_no":"","ref_date":"0001-01-01","buyer_id":0,"buyer":{"id":0,"type":0,"name":""},"rcpt_ldgr_id":0,"received_ledger":{"id":0,"type":0,"name":""},"amount":0,"remarks":"","brn_id":0,"cmp_id":0,"locked":false,"list":[]}');
      self.$data.voucher.list = [];
      self.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
    },
    loadBuyer() {
      const self = this;

      const requestOptions = {
        mode:'cors',
        headers: userService.authHeader()
      };

      //fetch the Ledgers
      self.$data.buyers = [];
      fetch(`${process.env.VUE_APP_ROOT_API}api/buyers`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.ok){
          if(_.isArray(resp.data)){
            self.$data.buyers = resp.data;
          }
        }else{
          swal (  {title:"Oops" ,  text: resp.msg,  type: "error"});
        }
      }).catch(function (err) {
        swal (  {title:"Oops" ,  text: err.toString(),  type: "error"});
      });

    },
    loadReceivedLedgers () {
      const self = this;

      const requestOptions = {
        mode: 'cors',
        headers: userService.authHeader()
      }

      $('#mycard').block({
        msg: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
          'box-shadow': '0 0 0 1px #ddd'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none'
        }
      });


      // fetch the Ledgers
      self.$data.ledgers = [];
      fetch(`${process.env.VUE_APP_ROOT_API}api/accounts/cash_bank_ledgers`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.ok) {
          if (_.isArray(resp.data)) {
            self.$data.ledgers = resp.data;
          }
        } else {
          swal({ title: 'Oops', text: resp.msg, type: 'error' })
        }
        $('#mycard').unblock();
      }).catch(function (err) {
        swal({ title: 'Oops', text: err.toString(), type: 'error' })
      });
    },
    loadAll(){
      const self = this;

      self.loadBuyer();
      self.loadReceivedLedgers();
    },
    loadPendingBills () {
      const self = this;

      const requestOptions = {
        mode: 'cors',
        headers: userService.authHeader()
      }

      $('#mycard').block({
        msg: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
          'box-shadow': '0 0 0 1px #ddd'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none'
        }
      });

      // fetch the Pending Bills
      self.$data.pendingbills = [];
      console.log(`${process.env.VUE_APP_ROOT_API}api/sale/pendinginvoices/${self.$data.voucher.buyer_id}?cmp_id=${self.$store.state.user.company.id}`);
      fetch(`${process.env.VUE_APP_ROOT_API}api/sale/pendinginvoices/${self.$data.voucher.buyer_id}?cmp_id=${self.$store.state.user.company.id}`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.ok) {
          if (_.isArray(resp.data)) {
            resp.data.forEach((line)=>{
              let brkup =  JSON.parse('{"id":0,"master_id":0,"idx":0,"saleinvoice_id":0,"invoice":{"id":0,"status":"Active","finyear":0,"doc_no":0,"doc_date":"2000-01-01","buyer_id":0,"net_amt":0,"rcpt_amt":0,"balance_amt":0,"rcpt_amount":0},"rcpt_amount":0}');
              brkup.saleinvoice_id = line.id;
              brkup.invoice = line;
              brkup.rcpt_amount = 0;

              self.$data.pendingbills.push(brkup);
            });
            self.offset_received_amount();
          }
        } else {
          swal({ title: 'Oops', text: resp.msg, type: 'error' })
        }
        $('#mycard').unblock();
      }).catch(function (err) {
        $('#mycard').unblock();
        swal({ title: 'Oops', text: err.toString(), type: 'error' })
      });
    },
    offset_received_amount(){
      const self = this;

      let cur_amt = self.voucher.amount;

      self.$data.pendingbills.forEach((line) =>{
        if( parseFloat(line.invoice.balance_amt) <= cur_amt ) {
          cur_amt = cur_amt - parseFloat(line.invoice.balance_amt);
          line.rcpt_amount = parseFloat(line.invoice.balance_amt);
        }else if(cur_amt >= 0 ) {
          line.rcpt_amount = cur_amt;
          cur_amt = 0;
        }
      });

      self.sum_display_totals();

    },
    perform_save_action () {
      const self = this;

      try {

        let myvoucher = JSON.parse(JSON.stringify(self.$data.voucher));
        myvoucher.finyear = self.$store.state.user.finyear;
        myvoucher.cmp_id = parseInt(self.$store.state.user.company.id);
        myvoucher.doc_date = moment(myvoucher.doc_date).format('YYYY-MM-DD');// + 'T00:00:00Z'
        myvoucher.buyer_id = parseInt(self.$data.voucher.buyer_id);
        myvoucher.rcpt_ldgr_id = parseInt(self.$data.voucher.rcpt_ldgr_id);
        myvoucher.amount = parseFloat(self.$data.voucher.amount);
        myvoucher.list = [];

        self.$data.pendingbills.forEach((line) =>{
          if( parseFloat(line.rcpt_amount) > 0 ) {
            myvoucher.list.push(line);
          }
        });


        console.log(JSON.stringify(myvoucher));

        if(myvoucher.list.length == 0) {
          alert('Invalid Amount Breakups');
          return;
        }else if(self.voucher.buyer_id < 1) {
          $('#cmbledger').focus();
          alert('Invalid buyer');
          return;
        }else if(self.voucher.rcpt_ldgr_id < 1) {
          $('#cmbledger').focus();
          alert('Invalid Received Ledger');
          return;
        }else if( parseFloat(self.voucher.amount) <= 0 ){
          $('#txtamount').focus();
          alert('Invalid Amount');
          return;
        }else if( parseFloat(self.voucher.amount) != parseFloat(self.total_rcpt_amt) ){
          $('#txtamount').focus();
          alert('Invalid Amount Breakups');
          return;
        }


        const requestOptions = {
          method: ((myvoucher.id == 0) ? 'POST' : 'PUT'),
          mode: 'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(myvoucher)
        }

        $('#mycard').block({
          msg: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        fetch(`${process.env.VUE_APP_ROOT_API}api/inv/partyreceipt`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok) {
            self.$data.pendingbills = [];
            self.$data.total_invoice_amt = 0;
            self.$data.total_rcpt_amt = 0;
            swal({ title: 'Success', type: 'success', text: resp.msg, onClose: () => { $('#cmbledger').focus()}, timer:1500  });
            self.clear();
            self.$emit('partyreceipt_saved', resp.data);

          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' , onClose: () => { $('#cmbledger').focus()}, timer:3000 });
          }
        }).catch(function (err) {
          swal({ title: 'Oops', text: err.toString(), type: 'error', onClose: () => { $('#cmbledger').focus()}, timer:3000  });
        }).finally(function () {
          $('#mycard').unblock();
        });
      }catch (e) {
        alert(e);
      }
    },
  }
}
</script>

<style scoped>
input:focus {
  background: #feff00;

}

textarea:focus {
  background: #feff00;

}

select:focus {
  background: #feff00;
}

button:focus {
  background: #feff00;
  color: #0a0a0a!important;
}
</style>
